import React from "react";
import HeroSection from "../components/HeroSection";
import OurBrands from '../components/OurBrands';
import CityEnterprises from "../components/CityEnterprises"; // Import the new component
import "../styles/Home.css";

const Home = () => {
  return (
    <div>
      <HeroSection />

      {/* Lubricants Section */}
      <div className="lubricants-section">
        <div className="lubricants-content">
          <h2>The Innovation Behind Our Lubricants</h2>
          <p>
            Our premium automobile lubricants are designed to enhance engine
            performance and extend vehicle life. We offer a range of products
            tailored to meet the needs of every driver, ensuring optimal
            protection and efficiency.
          </p>
          <p>
            Start with the driver – understand their vehicle needs and provide
            top-quality lubrication.
          </p>
        </div>

        {/* Centered Images with Captions */}
        <div className="lubricants-images">
          <div className="lubricant-item">
            <img src={require("../images/Lub.jpg")} alt="Lubricant 1" className="lubricant-img" />
            <p className="lubricant-caption">High-performance lubricant for long-lasting protection</p>
          </div>
          <div className="lubricant-item">
            <img src={require("../images/lub1.jpg")} alt="Lubricant 2" className="lubricant-img" />
            <p className="lubricant-caption">Advanced engine oil ensuring smooth operation</p>
          </div>
          <div className="lubricant-item">
            <img src={require("../images/lub2.jpg")} alt="Lubricant 3" className="lubricant-img" />
            <p className="lubricant-caption">Premium synthetic oil for maximum efficiency</p>
          </div>
        </div>
      </div>

      {/* City Enterprises Section Imported */}
      <OurBrands />
      <CityEnterprises />
     
    </div>
  );
};

export default Home;
